import moment, { isDate } from "moment";
export default {
  formatMonto(monto, currency) {
    let intMonto = parseInt(parseFloat(monto));
    if (currency)
      return Intl.NumberFormat("es-CL", {
        currency: "CLP",
        style: "currency",
      }).format(Math.abs(intMonto));
    else
      return Intl.NumberFormat("es-CL", { currency: "CLP" }).format(
        Math.abs(intMonto)
      );
  },
  formatMontoDec(monto, currency) {
    if (currency)
      return Intl.NumberFormat("es-CL", {
        currency: "CLP",
        style: "currency",
      }).format(Math.abs(monto));
    else
      return Intl.NumberFormat("es-CL", { currency: "CLP" }).format(
        Math.abs(monto)
      );
  },
  formatPorcentaje(valor) {
    valor = valor.replace(/,/g, ".");
    var num = parseFloat(valor);
    var preRedondeo = Number((Math.abs(num) * 100).toPrecision(15));
    var final = (Math.round(preRedondeo) / 100) * Math.sign(num);
    return final + "%";
  },
  formatFechaPalabras(fecha, srcDate = "DD/MM/YYYY HH:mm", hora = true) {
    let format = "DD MMM YYYY" + (hora ? " HH:mm" : "");
    let fechaMoment = srcDate ? moment(fecha, srcDate) : moment(fecha);
    if (!fechaMoment.isValid()) return fecha;
    return fechaMoment.locale("es").format(format);
  },
  formatFechaPalabras2(fecha, srcDate = "DD/MM/YYYY HH:mm", hora = true) {
    let format = "DD [de] MMMM, YYYY" + (hora ? " HH:mm" : "");
    let fechaMoment = srcDate ? moment(fecha, srcDate) : moment(fecha);
    if (!fechaMoment.isValid()) return fecha;
    return fechaMoment.locale("es").format(format);
  },
  formatDias(valor) {
    return valor === "1" ? valor + " día" : valor + " días";
  },
  formatFecha(fecha) {
    return moment(new Date(fecha)).format("DD/MM/YYYY");
  },
  fechaNombreDocs() {
    return moment(new Date(Date.now())).format("DDMMYYHHmmss");
  },
  formatPorcentaje2(valor) {
    var num = parseFloat(valor) * 100;
    return num.toFixed(2) + "%";
  },
  formatFecha2(fecha, srcFormat) {
    return moment(fecha, srcFormat).format("DD/MM/YYYY");
  },
  formatFechaHora(fecha, srcFormat) {
    return moment(fecha, srcFormat).format("DD/MM/YYYY HH:mm");
  },
  formatFechaHora2(fecha) {
    return moment(fecha).format("DD/MM/YYYY HH:mm");
  },
  capitalizeString(texto) {
    if (!texto) return "";
    let arr = texto.split(" ");

    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
    }
    return arr.join(" ");
  },
  desmonetizar(monto) {
    return monto.replace("$", "").split(".").join("");
  },

  convertirMarkdownAHTML(textoMarkdown) {
    const lineas = textoMarkdown.split("\n");
    let resultadoHTML = "";
    let dentroDeLista = false;
    let index = 1;

    for (const linea of lineas) {
      const trimmedLinea = linea.trim();

      // Detectar enlaces y convertirlos en etiquetas <a>.
      const enlaceRegex = /(https?:\/\/[^\s]+)/g;
      const lineConEnlaces = trimmedLinea.replace(
        enlaceRegex,
        '<a href="$1" target="_blank" style="word-break: break-all !important">$1</a>'
      );

      if (/^\d+\)/.test(lineConEnlaces)) {
        let indice = lineConEnlaces.match(/^\d+\)/)[0].split(")")[0];
        if (!dentroDeLista) {
          let start = indice > 1 ? indice : index;
          resultadoHTML +=
            '<ol start="' + start + '" class="custom-list-html">';
          index = index + 1;
          dentroDeLista = true;
        }
        resultadoHTML +=
          "<li>" +
          lineConEnlaces.substring(lineConEnlaces.indexOf(")") + 1).trim() +
          "</li>";
      } else {
        if (dentroDeLista) {
          resultadoHTML += "</ol>";
          dentroDeLista = false;
          index = 1;
        }
        if (lineConEnlaces !== "") {
          resultadoHTML += "<p>" + lineConEnlaces + "</p>";
        }
      }
    }

    if (dentroDeLista) {
      resultadoHTML += "</ol>";
    }
    return resultadoHTML;
  },
};
